import React from 'react';
import NoSSR from 'react-no-ssr';
import PropTypes from 'prop-types';
import styles from './index.css';
import { ContentShare } from '@ifeng/ui_pc_share';
import Ad from '@ifeng/ui_pc_ad';
import errorBoundary from '@ifeng/errorBoundary';
import Caption from './caption';
import MainContent from './mainContent';
import Vote from './vote';
import Loadable from 'react-loadable';
import LazyLoad from '@ifeng/ui_pc_lazyLoad';

const LoadComment = Loadable({
    loader: () => import('ThreeTerminal_pc/comment/comment'),
    loading() {
        return <div />;
    },
});

class Artical extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
        ad: PropTypes.object,
        commentAd: PropTypes.object,
    };

    render() {
        const { content, ad, commentAd } = this.props;
        const {
            noAd,
            noffhFlag,
            allowComment,
            title,
            newsTime,
            fhhAccountDetail,
            source,
            sourceUrl,
            summery,
            imagesInContent,
            pcUrl,
            url,
            commentUrl,
            skey,
            voteId,
            isOriginal,
            contentData,
            editorName,
            editorCode,
            videosPluginData,
            slidesPluginData,
            surveyPluginData,
        } = content;
        const pluginData = {
            videosPluginData,
            slidesPluginData,
            surveyPluginData,
        };
        const date = newsTime.split(' ')[0];
        const time = newsTime.split(' ')[1];
        const dateTime = `${date.split('-')[0]}年${date.split('-')[1]}月${date.split('-')[2]}日 ${time}`;
        const followUrl = `//gentie.ifeng.com/view.html?docUrl=${commentUrl}&docName=${encodeURIComponent(
            title,
        )}&skey=${skey}&pcUrl=${pcUrl}${noAd ? '&noAd' : ''}`;
        const captionData = {
            noffhFlag,
            title,
            url,
            dateTime,
            fhhAccountDetail,
            source,
            sourceUrl,
            summery,
            imagesInContent,
            commentUrl,
            followUrl,
            pcUrl,
        };

        const shareInfo = {
            url: pcUrl,
            title,
            summery,
            picUrl: imagesInContent && imagesInContent.length > 0 ? imagesInContent[0].url : '',
        };

        const commentConfig = {
            noAd,
            // 文章单页的页面地址
            docUrl: commentUrl,
            // 文章的标题
            docTitle: title,
            // 文章评论的skey，这个是在后端生成好后给到前端的
            skey,
            // 兼容以后的专题评论
            speUrl: '',
            // 文章pc的页面地址
            pcUrl,
            // 获取评论内容接口
            cmtNumUrl: '//comment.ifeng.com/get.php',
            // 评论内容字数长度
            cmtLength: 1000,
            // 提交评论内容接口
            cmtPostUrl: '//comment.ifeng.com/post.php',
            // 最热评论数量
            hotLimit: 2,
            // 推荐评论接口
            cmtVoteUrl: '//comment.ifeng.com/vote.php',
            // 现实回复的楼层
            replyLimit: 3,
            // 举报提交接口
            jubUrl: '//comment.ifeng.com/report',
            // 举报次数，便于每次回调函数名不同
            jubNum: 0,
            // 是否是评论详情页面
            isComment: false,
            // 是否允许评论
            allowComment,
        };

        return (
            <div className={styles.artical}>
                <Caption content={captionData} />
                <MainContent shareInfo={shareInfo} content={contentData} pluginData={pluginData} ad={ad} />
                <NoSSR>
                    <div className={styles.artical_line} />
                    <div className="clear" />
                    <div className={styles.vote_box}>
                        {editorName ? <p className={styles.author}>{`[责任编辑：${editorName} ${editorCode}]`}</p> : ''}
                        {isOriginal !== '0' ? (
                            <p className={styles.copyrightInfo}>(本文章版权归凤凰网所有，未经授权，不得转载)</p>
                        ) : (
                            ''
                        )}
                        <div className="clear" />
                        <Vote voteId={voteId} />
                        <div className={styles.share_box}>
                            <ContentShare shareInfo={shareInfo} />
                        </div>
                    </div>
                    <Ad content={commentAd} styleName={styles.comment_b} />
                    <LazyLoad>
                        <LoadComment articleInfo={commentConfig} />
                    </LazyLoad>
                </NoSSR>
            </div>
        );
    }
}

export default errorBoundary(Artical);
